var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hello_cashflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm0,16.92A7.92,7.92,0,1,1,19.92,12,7.93,7.93,0,0,1,12,19.92Zm2.73-6.38a2.22,2.22,0,0,1-2,2.33v2.36H11.31V15.9a6.08,6.08,0,0,1-2-.54l.27-1.61a5.42,5.42,0,0,0,2.43.7c.54,0,.92-.23.92-.68s-.22-.63-1.3-1c-1.53-.59-2.19-1.09-2.19-2.35a2.13,2.13,0,0,1,1.85-2.17V5.77h1.38V8.15a4.63,4.63,0,0,1,1.69.48l-.29,1.59a4.19,4.19,0,0,0-2-.62c-.57,0-.85.25-.85.6s.21.58,1.17.94C14.08,11.75,14.73,12.33,14.73,13.54Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflow);
export default __webpack_public_path__ + "static/media/cashflow.1db6944e.svg";
export { ForwardRef as ReactComponent };